/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
function equalize(sel) {
  var maxHeight = -1,
      elems = document.getElementsByClassName(sel);
  elems = [].slice.call(elems) // Now a true Array

  elems.forEach(function(e){
      maxHeight = Math.max(maxHeight, e.offsetHeight);
  });

  elems.forEach(function(e){
      e.style.height = maxHeight + "px";
  });
};

equalize('text-block-item');

window.onresize = function(event) {
    equalize('text-block-item');
};

console.log("DEV ENV")
*/


$(".ad_to_cart_coll").click(function () {
  var ID = $(this).attr("data-var_id");
  addItemToCart(ID, 1); // paste your id product number
  $(".cart_dr").trigger("click");
  
  /* CHARLES */
  setTimeout(function() {
  	$('.PageOverlay').addClass('is-visible');
  	$('#sidebar-cart').attr('aria-hidden', 'false');
  	$(html).addClass('no-scroll');
  }, 500);
  
});

function addItemToCart(variant_id, qty) {
  data = {
    id: variant_id,
    quantity: qty,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
      const header = document.querySelector(".js-cart");
      header.click();
    },
  });
}


$('.Drawer__Close').click(function () {
  /* CHARLES */
  $('.PageOverlay').removeClass('is-visible');
  $('#sidebar-cart').attr('aria-hidden', 'true');
  $(html).removeClass('no-scroll');
});

  /* JOIN */
window.addEventListener("story-embed-state-change" , (event) => {
    if (
event.detail.open
) {
        document.querySelector('.shopify-section--header').classList.add('hide');
    } else {
        document.querySelector('.shopify-section--header').classList.remove('hide');
    }
});